export default "__VITE_ASSET__D4GresZD__"